import { Search } from "/app/src/components/generic/components/search";

/**
 * InnerControls component renders search controls for filtering data.
 *
 * @param {Object} props - Props object.
 * @param {(searchString: string) => void} props.handleSearch - Callback to handle search input changes.
 * @returns {JSX.Element} The rendered InnerControls component.
 */
export default function InnerControls({
  handleSearch,
}: {
  handleSearch: (searchString: string) => void;
}) {
  return (
    <div className="pb-[10px] flex justify-between items-center gap-[42px]">
      <div className="flex flex-grow gap-[42px]">
        <Search box={false} setSearchString={handleSearch} />
      </div>
    </div>
  );
}
